import { Box, Chip, Typography } from "@mui/material";
import logo from "../../../asset/images/logo.png";
import JoinUs from "./JoinUsButton";

export default function HeroSection({prof,text}){
    return (
      <Box
        component="section"
        sx={{
          position: "relative",
          overflow: "hidden",
          textAlign: "center",
          mt: { xs: 1.5, md: 3 },
          mb: { xs: 4, md: 6 },
          px: { xs: 2, sm: 4, md: 7 },
          py: { xs: 4, sm: 5, md: 7 },
          borderRadius: { xs: "24px", md: "34px" },
          background:
            "linear-gradient(145deg, rgba(237,247,255,.98) 0%, rgba(255,255,255,1) 55%, rgba(255,247,235,.95) 100%)",
          border: "1px solid rgba(51,153,255,.16)",
          boxShadow: "0 22px 55px rgba(15, 62, 112, .11)",
          "&::before": {
            content: '""',
            position: "absolute",
            width: 260,
            height: 260,
            borderRadius: "50%",
            top: -145,
            right: -80,
            background: "rgba(51,153,255,.12)",
          },
          "&::after": {
            content: '""',
            position: "absolute",
            width: 210,
            height: 210,
            borderRadius: "50%",
            bottom: -140,
            left: -70,
            background: "rgba(250,175,60,.13)",
          },
        }}
      >
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <Chip
            label={prof ? "לבעלי מקצוע ונותני שירות" : "ללקוחות שמחפשים בעל מקצוע"}
            sx={{
              mb: 2.5,
              fontFamily: "Assistant",
              fontWeight: 700,
              color: "#1264ad",
              bgcolor: "rgba(51,153,255,.10)",
              border: "1px solid rgba(51,153,255,.18)",
            }}
          />
          <Box
            component="img"
            src={logo}
            alt="Bidit"
            sx={{
              display: "block",
              mx: "auto",
              width: { xs: 92, sm: 108, md: 120 },
              height: { xs: 92, sm: 108, md: 120 },
              objectFit: "contain",
              borderRadius: "50%",
              bgcolor: "#fff",
              p: 0.5,
              boxShadow: "0 14px 30px rgba(13, 88, 157, .16)",
            }}
          />
          <Typography
            component="h1"
            sx={{
              mt: { xs: 2.5, md: 3 },
              mb: 1.5,
              fontFamily: "Assistant",
              fontWeight: 800,
              fontSize: { xs: "2rem", sm: "2.55rem", md: "3.35rem" },
              lineHeight: 1.12,
              color: "#14395b",
              maxWidth: 900,
              mx: "auto",
            }}
          >
            {text.heroHeader}
          </Typography>
          <Typography
            component="h2"
            sx={{
              my: 1,
              fontFamily: "Assistant",
              fontWeight: 600,
              fontSize: { xs: "1.08rem", md: "1.35rem" },
              lineHeight: 1.65,
              color: "#42627e",
              maxWidth: 850,
              mx: "auto",
            }}
          >
            {text.heroSecond}
          </Typography>
          <Typography
            component="h2"
            sx={{
              mt: 0.5,
              mb: 3.5,
              fontFamily: "Assistant",
              fontWeight: 500,
              fontSize: { xs: "1rem", md: "1.22rem" },
              lineHeight: 1.7,
              color: "#57738c",
              maxWidth: 850,
              mx: "auto",
            }}
          >
            {text.heroThird}
          </Typography>
          <JoinUs prof={prof} text={"יאללה, מתאים לי!"}/>
        </Box>
      </Box>
    );
}
